// extracted by mini-css-extract-plugin
export var button = "styles-module--button--6fa8b";
export var buttonSection = "styles-module--buttonSection--b06a6";
export var buttonSectionDescription = "styles-module--buttonSectionDescription--92f29";
export var buttonSectionIcon = "styles-module--buttonSectionIcon--d9d3e";
export var buttonsBlock = "styles-module--buttonsBlock--e8387";
export var container = "styles-module--container--161bc";
export var contentBlock = "styles-module--contentBlock--e4856";
export var current = "styles-module--current--5eda2";
export var discordIcon = "styles-module--discordIcon--68081";
export var githubIcon = "styles-module--githubIcon--bcc13";
export var header = "styles-module--header--f88cf";
export var headingLink = "styles-module--headingLink--6fa4e";
export var tutorials = "styles-module--tutorials--3c45b";